import { Box } from 'grommet'
import styled from 'styled-components'

export const AccessContentWrapper = styled(Box)`
  position: relative;

  ${({ theme }) => theme.above.tablet`
    .image-wrapper {
      margin: 0 0 ${theme.spaces[3] + 4}px 0;
    }
  `}

  .title {
    ${({ theme }) => theme.below.tablet`
    padding-top: ${theme.spaces[4]}px;
    text-align: start;
    text-transform: uppercase;
  `}
  }
  .content {
    ${({ theme }) => theme.below.tablet`
    flex-direction: row;
    gap: ${theme.newSpaces.xs}px;
  `}
  }
  .image-wrapper {
    ${({ theme }) => theme.below.tablet`
    & > img {
      width: 100%;
    }
  `}
  }
  .subtitle {
    ${({ theme }) => theme.below.tablet`
    text-align: start;
    font-size: ${theme.typography.mobile.body.body3.fontSize}px;
    line-height: ${theme.typography.mobile.body.body3.lineHeight}px;
    margin-top: ${theme.newSpaces.xs}px;
  `}
  }
  .container {
    ${({ theme }) => theme.below.tablet`
      margin: 0px;
  `}
  }
  .wrapper {
    ${({ theme }) => theme.below.tablet`
      margin: 0px;
  `}
  }
`
